var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 42,
    viewBox: "0 0 85 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 21C11.6875 18.2152 12.8069 15.5445 14.7995 13.5754C16.7921 11.6062 19.4946 10.5 22.3125 10.5C25.1304 10.5 27.8329 11.6062 29.8255 13.5754C31.8181 15.5445 32.9375 18.2152 32.9375 21C32.9375 23.7848 31.8181 26.4555 29.8255 28.4246C27.8329 30.3938 25.1304 31.5 22.3125 31.5C19.4946 31.5 16.7921 30.3938 14.7995 28.4246C12.8069 26.4555 11.6875 23.7848 11.6875 21ZM0 21C0 9.4017 9.51363 0 21.25 0H63.75C75.4864 0 85 9.4017 85 21C85 32.5983 75.4864 42 63.75 42H21.25C9.51363 42 0 32.5983 0 21ZM21.25 5.25C17.0231 5.25 12.9693 6.90937 9.98049 9.86307C6.99162 12.8168 5.3125 16.8228 5.3125 21C5.3125 25.1772 6.99162 29.1832 9.98049 32.1369C12.9693 35.0906 17.0231 36.75 21.25 36.75H63.75C67.9769 36.75 72.0307 35.0906 75.0195 32.1369C78.0084 29.1832 79.6875 25.1772 79.6875 21C79.6875 16.8228 78.0084 12.8168 75.0195 9.86307C72.0307 6.90937 67.9769 5.25 63.75 5.25H21.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggle_off.20ecb3ef877dce68e56dedfcc20fe770.svg";
export { ForwardRef as ReactComponent };